import { useEffect } from "react"
import { Link } from "react-router-dom"

import { USER_ACCOUNT_LOADING_STATUS } from "../../ClientAuthorization/Default/common/constant"

import { Analytics } from "utils/analytics"
import { Spinner } from "components/Spinner"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { GiftCertificateBanner } from "modules/BookingCommon/components"
import { AdviceBlockDiscount, TelegramBlock } from "components"
import { UserInfoPageHash } from "modules/ClientAccount"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { createdTimeRequestLoader } from "modules/BookingCommon/common/queries"
import { SessionDetails, SessionInfoCard } from "modules/Booking/AfterPaymentPage/components"
import { useBannerSettings } from "utils/Banners/useBannerSettings"

export function TimeRequestSession() {
    const timeRequestHash = createdTimeRequestLoader.getHash()
    const { data: timeRequestResponse } = createdTimeRequestLoader.useGet(timeRequestHash)
    const [{ userAccount, loading: clientLoading }] = useClientContext()
    const { isShowTelegramBanner } = useBannerSettings()

    useEffect(() => {
        if (timeRequestResponse?.client_data?.email) {
            Analytics.user_went_to_payment_success_after_time_request_modal({
                name: timeRequestResponse.client_data.name,
                email: timeRequestResponse.client_data.email,
                orderId: timeRequestResponse.order_id,
                price: timeRequestResponse.price,
            })
        }
    }, [timeRequestResponse])

    const showAdviceBlock =
        clientLoading === USER_ACCOUNT_LOADING_STATUS.READY && userAccount.allowed_referral_program

    return (
        <div className="redesign-container">
            {timeRequestResponse ? (
                <div className="after-payment">
                    <div className="after-payment__left">
                        <SessionDetails
                            sessionType={SESSION_TYPE.TIME_REQUEST}
                            phone={timeRequestResponse.client_data.phone}
                            email={timeRequestResponse.client_data.email}
                        />
                        {isShowTelegramBanner && !userAccount.telegram_account && (
                            <TelegramBlock
                                button={
                                    <Link
                                        className="button-primary is-inline-block telegramButton w-100 text-center"
                                        to={`/my/userinfo#${UserInfoPageHash.TELEGRAM_ACCOUNT}`}
                                    >
                                        Подключить
                                    </Link>
                                }
                            />
                        )}
                        <SessionInfoCard
                            sessionType={SESSION_TYPE.TIME_REQUEST}
                            psy={timeRequestResponse.psy}
                            serviceType={timeRequestResponse.service_type}
                            isOnline={timeRequestResponse.is_online}
                            psyPhone={timeRequestResponse.psy_phone}
                            psyFullName={timeRequestResponse.psy_full_name}
                            price={timeRequestResponse.price}
                            priceUsd={timeRequestResponse.price_usd}
                            paymentSystem={timeRequestResponse.payment_system}
                            sessionDateTimes={timeRequestResponse.requested_session_datetimes}
                            callEnabled={false}
                        />
                        {showAdviceBlock && (
                            <AdviceBlockDiscount className="after-payment__last-widget is-booking" />
                        )}
                    </div>
                    <div className="after-payment__banners">
                        <GiftCertificateBanner />
                    </div>
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    )
}
